/**
 * Ordena notificações pela data em que foram lidas (mais recentes primeiro).
 * Fallback: createdAt.
 *
 * @param {Array<{ readAt?: string|null, createdAt?: string|null }>} [notifications]
 * @returns {Array}
 */
export function sortNotificationsByReadAtDesc(notifications) {
  if (!Array.isArray(notifications)) return [];

  return [...notifications].sort((a, b) => {
    const aTime =
      Date.parse(a?.readAt || "") || Date.parse(a?.createdAt || "") || 0;
    const bTime =
      Date.parse(b?.readAt || "") || Date.parse(b?.createdAt || "") || 0;
    return bTime - aTime;
  });
}
